import { render } from "./ImageExplainerPropsCmp.vue?vue&type=template&id=4d2dd37a"
import script from "./ImageExplainerPropsCmp.vue?vue&type=script&lang=js"
export * from "./ImageExplainerPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__